import React, { memo } from 'react';
import { withRouter } from "react-router-dom";
import { Fab, Hidden } from "@material-ui/core";
import { ChevronLeft } from "@material-ui/icons";

const BackButton = memo(({ history, isPost }) => {
  return (
    <React.Fragment>
      <Hidden only={['lg']}>
        <div onClick={() => history.goBack()}>
          <Fab aria-label={'back'} style={{ backgroundColor: '#ff8000', color: '#fff', width: 36, height: 36, marginLeft:  isPost ? 40 : 0 }}>
            <ChevronLeft />
          </Fab>
          <span style={{ color: '#ff8000', marginLeft: 10 }}>
        Back
      </span>
        </div>
      </Hidden>
      <Hidden mdDown>
        <div onClick={() => history.goBack()} style={{ marginLeft: -25 }}>
          <Fab aria-label={'back'} style={{ backgroundColor: '#ff8000', color: '#fff', width: 36, height: 36 }}>
            <ChevronLeft />
          </Fab>
          <span style={{ color: '#ff8000', marginLeft: 10 }}>
        Back
      </span>
        </div>
      </Hidden>
    </React.Fragment>
  );
});

export default withRouter(BackButton);
